import Addition from "./gs_components/Addition.jsx";
import AND from "./gs_components/AND.jsx";
import AVERAGE from "./gs_components/AVERAGE.jsx";
import AVERAGEIF from "./gs_components/AVERAGEIF.jsx";
import AVERAGEIFS from "./gs_components/AVERAGEIFS.jsx";
import COUNT from "./gs_components/COUNT.jsx";
import COUNTA from "./gs_components/COUNTA.jsx";
import COUNTBLANK from "./gs_components/COUNTBLANK.jsx";
import COUNTIF from "./gs_components/COUNTIF.jsx";
import COUNTIFS from "./gs_components/COUNTIFS.jsx";
import Division from "./gs_components/Division.jsx";
import Double_Click_to_Fill from "./gs_components/Double_Click_to_Fill.jsx";
import Fills from "./gs_components/Fills.jsx";
import Fonts from "./gs_components/Fonts.jsx";
import Font_Characteristics from "./gs_components/Font_Characteristics.jsx";
import Font_Color from "./gs_components/Font_Color.jsx";
import Font_Size from "./gs_components/Font_Size.jsx";
import GS_Absolute_Reference from "./gs_components/GS_Absolute_Reference.jsx";
import GS_Add_Cells from "./gs_components/GS_Add_Cells.jsx";
import GS_Arithmetic_Operators from "./gs_components/GS_Arithmetic_Operators.jsx";
import GS_Color_Scale_Formatting from "./gs_components/GS_Color_Scale_Formatting.jsx";
import GS_Conditional_Formatting from "./gs_components/GS_Conditional_Formatting.jsx";
import GS_Delete_Cells from "./gs_components/GS_Delete_Cells.jsx";
import GS_Fill from "./gs_components/GS_Fill.jsx";
import GS_Formatting from "./gs_components/GS_Formatting.jsx";
import GS_Format_Borders from "./gs_components/GS_Format_Borders.jsx";
import GS_Format_Clear from "./gs_components/GS_Format_Clear.jsx";
import GS_Format_Colors from "./gs_components/GS_Format_Colors.jsx";
import GS_Format_Fonts from "./gs_components/GS_Format_Fonts.jsx";
import GS_Format_Grids from "./gs_components/GS_Format_Grids.jsx";
import GS_Format_Numbers from "./gs_components/GS_Format_Numbers.jsx";
import GS_Format_Painter from "./gs_components/GS_Format_Painter.jsx";
import GS_Formulas from "./gs_components/GS_Formulas.jsx";
import GS_Functions from "./gs_components/GS_Functions.jsx";
import GS_Get_Started from "./gs_components/GS_Get_Started.jsx";
import GS_HOME from "./gs_components/GS_HOME.jsx";
import GS_Introduction from "./gs_components/GS_Introduction.jsx";
import GS_Location_Settings from "./gs_components/GS_Location_Settings.jsx";
import GS_Move_Cells from "./gs_components/GS_Move_Cells.jsx";
import GS_Overview from "./gs_components/GS_Overview.jsx";
import GS_Parentheses from "./gs_components/GS_Parentheses.jsx";
import GS_Ranges from "./gs_components/GS_Ranges.jsx";
import GS_Relative_Reference from "./gs_components/GS_Relative_Reference.jsx";
import GS_Single_Color_Formatting from "./gs_components/GS_Single_Color_Formatting.jsx";
import GS_Sort from "./gs_components/GS_Sort.jsx";
import GS_Sort_By_Range from "./gs_components/GS_Sort_By_Range.jsx";
import GS_Sort_Range from "./gs_components/GS_Sort_Range.jsx";
import GS_Sort_Sheet from "./gs_components/GS_Sort_Sheet.jsx";
import GS_Syntax from "./gs_components/GS_Syntax.jsx";
import GS_Undo_Redo from "./gs_components/GS_Undo_Redo.jsx";
import IF from "./gs_components/IF.jsx";
import IFS from "./gs_components/IFS.jsx";
import MAX from "./gs_components/MAX.jsx";
import MEDIAN from "./gs_components/MEDIAN.jsx";
import MIN from "./gs_components/MIN.jsx";
import MODE from "./gs_components/MODE.jsx";
import Multiplication from "./gs_components/Multiplication.jsx";
import OR from "./gs_components/OR.jsx";
import STDEVP from "./gs_components/STDEVP.jsx";
import STDEVS from "./gs_components/STDEVS.jsx";
import Subtraction from "./gs_components/Subtraction.jsx";
import SUM from "./gs_components/SUM.jsx";
import SUMIF from "./gs_components/SUMIF.jsx";
import SUMIFS from "./gs_components/SUMIFS.jsx";
import VLOOKUP from "./gs_components/VLOOKUP.jsx";
import XOR from "./gs_components/XOR.jsx";

const gsComponentsMap = {
  "<Addition />": Addition,
  "<AND />": AND,
  "<AVERAGE />": AVERAGE,
  "<AVERAGEIF />": AVERAGEIF,
  "<AVERAGEIFS />": AVERAGEIFS,
  "<COUNT />": COUNT,
  "<COUNTA />": COUNTA,
  "<COUNTBLANK />": COUNTBLANK,
  "<COUNTIF />": COUNTIF,
  "<COUNTIFS />": COUNTIFS,
  "<Division />": Division,
  "<Double_Click_to_Fill />": Double_Click_to_Fill,
  "<Fills />": Fills,
  "<Fonts />": Fonts,
  "<Font_Characteristics />": Font_Characteristics,
  "<Font_Color />": Font_Color,
  "<Font_Size />": Font_Size,
  "<GS_Absolute_Reference />": GS_Absolute_Reference,
  "<GS_Add_Cells />": GS_Add_Cells,
  "<GS_Arithmetic_Operators />": GS_Arithmetic_Operators,
  "<GS_Color_Scale_Formatting />": GS_Color_Scale_Formatting,
  "<GS_Conditional_Formatting />": GS_Conditional_Formatting,
  "<GS_Delete_Cells />": GS_Delete_Cells,
  "<GS_Fill />": GS_Fill,
  "<GS_Formatting />": GS_Formatting,
  "<GS_Format_Borders />": GS_Format_Borders,
  "<GS_Format_Clear />": GS_Format_Clear,
  "<GS_Format_Colors />": GS_Format_Colors,
  "<GS_Format_Fonts />": GS_Format_Fonts,
  "<GS_Format_Grids />": GS_Format_Grids,
  "<GS_Format_Numbers />": GS_Format_Numbers,
  "<GS_Format_Painter />": GS_Format_Painter,
  "<GS_Formulas />": GS_Formulas,
  "<GS_Functions />": GS_Functions,
  "<GS_Get_Started />": GS_Get_Started,
  "<GS_HOME />": GS_HOME,
  "<GS_Introduction />": GS_Introduction,
  "<GS_Location_Settings />": GS_Location_Settings,
  "<GS_Move_Cells />": GS_Move_Cells,
  "<GS_Overview />": GS_Overview,
  "<GS_Parentheses />": GS_Parentheses,
  "<GS_Ranges />": GS_Ranges,
  "<GS_Relative_Reference />": GS_Relative_Reference,
  "<GS_Single_Color_Formatting />": GS_Single_Color_Formatting,
  "<GS_Sort />": GS_Sort,
  "<GS_Sort_By_Range />": GS_Sort_By_Range,
  "<GS_Sort_Range />": GS_Sort_Range,
  "<GS_Sort_Sheet />": GS_Sort_Sheet,
  "<GS_Syntax />": GS_Syntax,
  "<GS_Undo_Redo />": GS_Undo_Redo,
  "<IF />": IF,
  "<IFS />": IFS,
  "<MAX />": MAX,
  "<MEDIAN />": MEDIAN,
  "<MIN />": MIN,
  "<MODE />": MODE,
  "<Multiplication />": Multiplication,
  "<OR />": OR,
  "<STDEVP />": STDEVP,
  "<STDEVS />": STDEVS,
  "<Subtraction />": Subtraction,
  "<SUM />": SUM,
  "<SUMIF />": SUMIF,
  "<SUMIFS />": SUMIFS,
  "<VLOOKUP />": VLOOKUP,
  "<XOR />": XOR,
};

export default gsComponentsMap;
